import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["loader"]

  static values = {
    url: String,
    loading: Boolean,
    rootId: String,
    rootMargin: { type: String, default: "200px" }
  }

  connect() {
    this.buildObserver()
    this.observeLoader()
  }

  disconnect() {
    this.disconnectObserver()
  }

  loaderTargetConnected() {
    this.observeLoader()
  }

  loaderTargetDisconnected() {
    this.disconnectObserver()
    this.buildObserver()
  }

  buildObserver() {
    this.observer = new IntersectionObserver(
      (entries) => this.handleIntersection(entries),
      {
        root: this.observerRoot(),
        rootMargin: this.rootMarginValue,
        threshold: 0
      }
    )
  }

  observerRoot() {
    if (!this.hasRootIdValue) return this.element

    return document.getElementById(this.rootIdValue) || this.element
  }

  observeLoader() {
    if (!this.observer || !this.hasLoaderTarget || !this.urlValue || this.loadingValue) return

    this.observer.observe(this.loaderTarget)
  }

  disconnectObserver() {
    if (this.observer) {
      this.observer.disconnect()
    }
  }

  async handleIntersection(entries) {
    const intersects = entries.some((entry) => entry.isIntersecting)
    if (!intersects || this.loadingValue || !this.urlValue) return

    this.loadingValue = true

    try {
      const response = await fetch(this.urlValue, {
        headers: {
          Accept: "text/vnd.turbo-stream.html"
        },
        credentials: "same-origin"
      })

      if (!response.ok) throw new Error(`Could not load next page: ${response.status}`)

      const html = await response.text()
      Turbo.renderStreamMessage(html)
      this.urlValue = this.loaderTarget.dataset.nextUrl || ""
    } catch (error) {
      this.disconnectObserver()
      console.error(error)
    } finally {
      this.loadingValue = false
      this.observeLoader()
    }
  }
}
